<template>
  <v-container grid-list-md fluid class="pa-2">
    <v-layout v-if="componentLoading" row wrap justify-center>
      <v-progress-circular :size="64" :width="3" indeterminate color="primary" />
    </v-layout>
    <v-layout v-else row wrap>
      <v-flex xs12 sm6>
        <v-card id="helpDeskContent" class="max-shadow">
          <v-card-title class="pa-1">
            <v-container grid-list-xs class="pa-4">
              <v-layout row wrap>
                <v-layout column>
                  <v-flex xs12 class="pa-0">
                    <div class="title">Admin</div>
                  </v-flex>
                  <v-flex xs12 class="pa-0">
                    <div class="body-1">Selected person will get the tickets</div>
                  </v-flex>
                </v-layout>
                <v-btn color="primary" flat :loading="loading" @click="saveSettings">save</v-btn>
              </v-layout>
            </v-container>
          </v-card-title>
          <v-divider class="pt-3" />
          <v-card-text class="pt-0">
            <vizmo-autocomplete
              v-model="admin"
              :items="employees"
              label="Admin"
              placeholder="Type to search Employees"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="snackbar"
      :right="true"
      :timeout="4000"
      :top="true"
      :color="snackColor"
    >{{ snackText }}</v-snackbar>
  </v-container>
</template>
<script>
import VizmoAutoCompelete from '@/components/common/VizmoAutoComplete';
import { firestore } from '@/firebase';
import _get from 'lodash/get';

export default {
  name: 'HelpDesk',
  components: {
    'vizmo-autocomplete': VizmoAutoCompelete
  },
  data() {
    return {
      componentLoading: true,
      admin: {},
      loading: false,
      employees: [],

      snackbar: false,
      snackColor: 'success',
      snackText: ''
    };
  },
  computed: {
    cid() {
      const role = _get(this.$store.state.profile, 'role');
      const cid = _get(this.$store.state.profile, 'cid');
      return role === 'admin' ? cid : 'mEUEuIuvoegBwnaFTTZZ';
    },
    settingsRef() {
      const role = _get(this.$store.state.profile, 'role');
      return role === 'admin'
        ? firestore.collection('tenants').doc(this.cid)
        : firestore.doc('settings/helpDesk');
    }
  },
  created() {
    this.$store.commit('setToolbarTitle', {
      toolbarTitle: 'Help Desk Settings'
    });
  },
  mounted() {
    const adminPromise = this.settingsRef.get().then(adminSnaphot => {
      const admin = adminSnaphot.data();
      return admin;
    });
    const employeePromise = firestore
      .collection('users')
      .where('cid', '==', this.cid)
      .get()
      .then(users => {
        const docs = [];
        users.forEach(userSnapshot => {
          docs.push({ ...userSnapshot.data(), ...{ id: userSnapshot.id } });
        });
        const employees = [];
        docs.forEach(doc => {
          employees.push({ ...{ id: doc.id }, ...doc.profile });
        });
        return employees;
      });
    Promise.all([adminPromise, employeePromise]).then(results => {
      this.admin =
        this.$store.state.profile.role === 'admin'
          ? results[0].helpDeskAdmin
          : results[0].admin;
      this.employees = results[1];
      this.componentLoading = false;
    });
  },
  methods: {
    saveSettings() {
      const defaultAdmin = {
        name: this.admin.name,
        email: this.admin.email,
        phone: this.admin.phone || '',
        uid: this.admin.id
      };
      if (this.$store.state.profile.role === 'admin') {
        this.settingsRef
          .update({ helpDeskAdmin: defaultAdmin })
          .then(() => {
            this.loading = false;
            this.snackText = 'Updated successfully';
            this.snackColor = 'primary';
            this.snackbar = true;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.settingsRef
          .update({ admin: defaultAdmin })
          .then(() => {
            this.loading = false;
            this.snackText = 'Updated successfully';
            this.snackColor = 'primary';
            this.snackbar = true;
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>
<style>
#helpDeskContent {
  height: calc(100vh - var(--toolbar-height));
  overflow-y: scroll;
}
</style>

